/* eslint-disable */
(function(zr) {
  'use strict';

  var errorDestination;
  var errorTrapper = {
    errors: []
  };

  // Trap error events to be logged later
  errorTrapper.trapErrors = function() {
    if (typeof window.onerror == 'object') {
      window.onerror = function (err, url, line, column, oerror) {
        // Store the error for later use
        var errorObj = {
          err: err,
          url: url,
          line: line,
          column: column,
          oerror: oerror
        };

        zr.errorTrapper.errors.push(errorObj);
      };
    }
  };

  // Log the existing errors, and take errors.push over
  errorTrapper.startLogger = function(destination) {
    errorDestination = destination;

    while (errorTrapper.errors.length) {
      logError(errorTrapper.errors.shift());
    }

    errorTrapper.errors = {
      push: logError
    }
  };

  // When the logger is enabled, use this instead of errors.push
  var logError = function(errorObj) {
    var err = errorObj.err;
    var url = errorObj.url;
    var line = errorObj.line;
    var column = errorObj.column;
    var oerror = errorObj.oerror;
    var stack = oerror ? oerror.stack : 'NO STACK';

    if (errorDestination === 'asEvent') {
      if ($.log_event) {
        if (typeof err == 'object') {
          err = err.toString()
        }

        if (typeof line == 'object') {
          line = line.toString()
        }

        if (typeof url == 'object') {
          url = url.toString()
        }

        // Clean up error stack to be shorter, Mixpanel limits it to 256 chars
        if (stack && stack.length > 256) {
          // Delete the site URL
          stack = stack.split(window.location.origin).join('');

          // Get all (unique) urls mentioned
          var urls = stack.match(/\/[^:]+/g);
          if (urls) {
            urls = urls.filter(function (x, i, a) {
              return a.indexOf(x) == i;
            });

            urls = urls.join("\n");
          }

          // Replace the error in the stack, it's already in errordescription (err)
          // The "Uncaught " bit is for Chrome
          stack = stack.replace(err.replace('Uncaught ', ''), '').replace().trim();

          // Delete the "    at" parts
          stack = stack.replace(/^\s*at /mg, '');

          // Delete the paths
          stack = stack.replace(/\/[^\n]+\//g, '');

          // Only use the last 256 chars
          stack = stack.substring(stack.length - 256);
        }

        $.log_event('js_error', { errorDescription: err, errorLine: line, errorColumn: column, errorUrl: url, errorStack: stack, errorUrls: urls, non_interaction: 1 });
      }
    }
  };

  errorTrapper.trapErrors();
  zr.errorTrapper = errorTrapper;
})(window.zr = window.zr || {});
